import { useTranslation as useReactI18next } from 'react-i18next'

// Shim that adapts react-i18next to the widget's i18n API.
// This allows us to import widget components directly into the dashboard.

export function setLocale(_locale: string) {
  // The dashboard locale is managed by react-i18next; this is a no-op.
}

export function getLocale(): string {
  // Not used by dashboard components.
  return 'en'
}

export function t(key: string, _vars?: Record<string, string>): string {
  // This standalone t() is not reactive; components should use useTranslation().
  return key
}

export function useTranslation() {
  const { t: rt, i18n } = useReactI18next()
  const t = (key: string, vars?: Record<string, string>) => rt(key, vars) as string
  return { locale: i18n.language, t }
}
